import { render, staticRenderFns } from "./CreateLessonObjective.vue?vue&type=template&id=20a299c8&scoped=true"
import script from "./CreateLessonObjective.vue?vue&type=script&lang=js"
export * from "./CreateLessonObjective.vue?vue&type=script&lang=js"
import style0 from "./CreateLessonObjective.vue?vue&type=style&index=0&id=20a299c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a299c8",
  null
  
)

export default component.exports